import { render } from "./Model3D.vue?vue&type=template&id=0ae64092&scoped=true"
import script from "./Model3D.vue?vue&type=script&lang=js"
export * from "./Model3D.vue?vue&type=script&lang=js"

import "./Model3D.vue?vue&type=style&index=0&id=0ae64092&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae64092"]])

export default __exports__